<template>
	 <v-container>
		 <v-dialog title="创建学生" v-model="hideShow" width="600px" persistent>
			<v-card>
				<v-card-title>
					<span>添加学员信息</span>
					<v-spacer></v-spacer>
					<v-icon @click="cancel">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-row dense>
						<v-col cols="6">
							<v-text-field label="学员姓名" v-model="add.student.studentName" dense outlined></v-text-field>
						</v-col>
						<v-col cols="6">
							<v-select v-model="add.student.status" :items="statusItems" label="学员状态" item-text="name"
								item-value="id" outlined dense></v-select>
						</v-col>
						<v-col cols="6" class="mt-n3">
							<v-radio-group label="性别:" v-model="add.student.gender" row>
								<v-radio label="男生" value="1"></v-radio>
								<v-radio label="女生" value="0"></v-radio>
							</v-radio-group>
						</v-col>
						<v-col cols="6" class="d-flex">
							<v-select v-model="add.student.studentSource" :items="studentSourceItems" label="生源类型" item-text="sourceName"
								item-value="id" outlined dense></v-select>
							<v-btn color="info" small class="ml-1 mt-1" @click="showCreateSource('1')">添加</v-btn>
						</v-col>
						<v-col cols="6">
							<v-text-field label="联系人关系" placeholder="如:爸爸/妈妈/本人" v-model="add.student.contactorCall" dense outlined>
							</v-text-field>
						</v-col>
						<v-col cols="6">
							<v-text-field label="联系人手机" v-model="add.student.contactorMobile" dense outlined>
							</v-text-field>
						</v-col>
						
						<v-col cols="12">
							<span style="color:red;">以下为选填项目:</span>
						</v-col>
						<v-col cols="4">
							<!-- <v-menu ref="menuBirthday" v-model="add.menuBirthday" :close-on-content-click="false"
								transition="scale-transition" offset-y min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="add.student.birthday" label="学员生日" readonly v-bind="attrs"
										v-on="on" dense clearable outlined></v-text-field>
								</template>
								<v-date-picker v-model="add.student.birthday" locale="zh-cn" @input="add.menuBirthday=false" no-title scrollable>
								</v-date-picker>
							</v-menu> -->
							<v-text-field label="学员年龄(几岁)" v-model="add.student.age" type="number" dense outlined></v-text-field>
							
						</v-col>
						<v-col cols="8">
							<!-- 上传图片组件 -->
							<cutImageUpload :show="hideShow" title="上传学员头像" :waterText="add.student.studentName" @success="uploadSuccess"></cutImageUpload>
						</v-col>
						<v-col cols="6" class="d-flex">
							<v-select v-model="add.student.fromSchool" :items="fromSchoolItems" label="就读学校" item-text="sourceName"
								item-value="id" outlined dense></v-select>
							<v-btn color="info" small class="ml-1 mt-1" @click="showCreateSource('2')">添加</v-btn>
						</v-col>
						<v-col cols="6" class="d-flex">
							<v-select v-model="add.student.fromRegion" :items="fromRegionItems" label="居住片区" item-text="sourceName"
								item-value="id" outlined dense></v-select>
							<v-btn color="info" small class="ml-1 mt-1" @click="showCreateSource('3')">添加</v-btn>
						</v-col>
						<v-col cols="6">
							<v-text-field label="身份证号" v-model="add.student.idCardNo" dense outlined></v-text-field>
						</v-col>
						
						<v-col cols="6">
							<v-text-field label="家庭住址" v-model="add.student.homeAddress" dense outlined></v-text-field>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="cancel">取消</v-btn>
					<v-btn @click="submitAddStudent" :loading="add.submiting" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- 添加生源组件 -->
		<createStudentSource :show="createSourceShow" :dataType="createSourceDataType"  @cancel="createSourceShow=false" @success="createSourceSuccess"></createStudentSource>
	 </v-container>
</template>

<script>
	import utils from "../config/utils"
	import global from "../config/global"
	import uploadPhoto from "./upload_photo.vue"
	import createStudentSource from "./create_student_source.vue"
	import cutImageUpload from "./cut_image_upload.vue"
	export default {
		name:"create-student",
		components:{uploadPhoto,createStudentSource,cutImageUpload},
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
		},
		watch:{
			show(newVal,oldVal){
				console.log("create student show=",newVal);
				this.hideShow = newVal;
				if(this.hideShow){

				}
			}
		},
		data(){
			this.submitAddStudent = utils.throttle(this.submitAddStudent,500)
			return {
				imgPrev:global.config.imgPre,
				shopId:"",
				add: {
					submiting:false,
					menuBirthday: false,
					student: {
						studentName: "",
						gender: "",
						avatar: "",
						birthday: "",
						contactorCall: "",
						contactorMobile: "",
						homeAddress: "",
						status: "1",
						studentSource:"",
						age:"",
						idCardNo:""
					},
				},
				statusItems: [{
					id: "1",
					name: "正式学员"
				}, {
					id: "3",
					name: "意向学员"
				}],
				hideShow:this.show,
				createSourceShow:false,
				createSourceDataType:"", // 创建生源的类型
				studentSourceItems:[],// 生源类型
				fromSchoolItems:[],
				fromRegionItems:[]
				
				
			}
		},
		mounted() {
			console.log("create-student mounted");
			this.shopId = utils.getCurrentShopId(); 
			this.getStudentSourceList('1');
			this.getStudentSourceList('2');
			this.getStudentSourceList('3');
		},
		methods:{
			
			cancel(){
				this.$emit("cancel","");
			},
			uploadSuccess(e){
				console.log("上传学员头像成功",e);
				this.add.student.avatar = e.key;
			},
			
			submitAddStudent() {
				
				if (!this.add.student.studentName) {
					this.$noty.error('姓名不能为空');
					return
				}
				if (!this.add.student.gender) {
					this.$noty.error('性别不能为空');
					return
				}
				
				if (!this.add.student.status) {
					this.$noty.error('学员状态不能为空');
					return
				}
				
				if(this.add.student.age){
					if(!utils.isInt(this.add.student.age)){
						this.$noty.error('学员年龄只能输入正整数');
						return
					}
				}
				
				this.add.submiting = true;
				// api
				const that = this;
				let url = `/edu/student/create`;
				let postData = {
					...this.add.student
				};
				postData.shopId = this.shopId;
						
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.add.submiting = false;
							that.$noty.success("添加成功");
							that.$emit("success","");
							
							return;
						} else {
							that.add.submiting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.add.submiting = false;
						that.$noty.error('网络请求失败');
					}
			
				});
			
			},
			getStudentSourceList(dataType){
				
				// api
				const that = this;
				let url = `/edu/shop/student/source/list/${this.shopId}/${dataType}`;	
				
				console.log(url);
				this.axios.get(url).catch(() => {
					
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							
							const result = res.data["data"]||[];
							
							if (dataType=='1'){
								that.studentSourceItems = result;
							}else if (dataType=='2'){
								that.fromSchoolItems = result;
							}else if (dataType=='3'){
								that.fromRegionItems = result;
							}
							
							
							return;
						} 
					} 
							
				});
			},
			showCreateSource(dataType){
				this.createSourceDataType = dataType;
				this.createSourceShow = true;
			},
			createSourceSuccess(){
				this.getStudentSourceList(this.createSourceDataType);
				this.createSourceShow = false;
			}
		}
	}
	
</script>

<style>
</style>
